export default "__VITE_ASSET__W2wh$CKu__"